export const preLoadImage = async (src: string[]): Promise<boolean> => {
    await Promise.all(src.map(async (value) => {
        var img = new Image();
        img.src = value;
        await img.decode();
        console.log(`${img.src} load completed `);
    }))
    console.log('preLoadImage completed!');
    return true;
}